module.exports = __webpack_public_path__ + "assets/img/mecha-btn-87d65a97.png";